export function products(
  state = {
    products: ["content", "media"],
    isLoadingProducts: true,
  },
  action
) {
  switch (action.type) {
    case "FETCH_PRODUCTS_SUCCESS":
      return {
        ...state,
        products: action.payload.data,
        isLoadingProducts: false,
      };

    default:
      return state;
  }
}

/**
 * System roles that receive the "code" product below. Exported because
 * usePermission("CODE") must grant layout/view-source editing to exactly this
 * set — a role added here and not there silently loses code access in Studio
 * while the global menu still offers the Code app.
 */
export const CODE_ROLE_ZUIDS = [
  "31-71cfc74-0wn3r", // owner
  "31-71cfc74-4dm13", // admin
  "31-71cfc74-4cc4dm13", // account admin
  "31-71cfc74-d3v3l0p3r", // developer
  "31-71cfc74-d3vc0n", // dev console
];

export function fetchProducts() {
  return (dispatch, getState) => {
    let data;
    switch (getState().userRole.systemRoleZUID) {
      // owner: 31-71cfc74-0wn3r
      // admin: 31-71cfc74-4dm13
      // developer: 31-71cfc74-d3v3l0p3r
      // publisher: 31-71cfc74-p0bl1shr
      // contributor: 31-71cfc74-c0ntr1b0t0r
      // seo: 31-71cfc74-s30
      case "31-71cfc74-0wn3r":
      case "31-71cfc74-4dm13":
      case "31-71cfc74-4cc4dm13":
        data = [
          "launchpad",
          "content",
          "blocks",
          "schema",
          "media",
          "code",
          "leads",
          "redirects",
          "reports",
          // "release",
          "apps",
          "settings",
        ];
        break;
      case "31-71cfc74-d3v3l0p3r":
      case "31-71cfc74-d3vc0n":
        data = [
          "launchpad",
          "content",
          "blocks",
          "schema",
          "media",
          "code",
          "leads",
          "redirects",
          "reports",
          // "release",
          "apps",
          "settings",
        ];
        break;
      case "31-71cfc74-p0bl1shr":
        data = [
          "launchpad",
          "content",
          "blocks",
          "media",
          "leads",
          "reports",
          "apps",
          // "release"
        ];
        break;
      case "31-71cfc74-s30":
        data = [
          "launchpad",
          "content",
          "blocks",
          "media",
          "leads",
          "redirects",
          "reports",
          "apps",
        ];
        break;
      case "31-71cfc74-c0ntr1b0t0r":
        data = ["launchpad", "content", "blocks", "media", "apps"];
        break;
      case "31-71cfc74-m3d14":
        data = ["media"];
        break;
      default:
        data = [];
    }

    if (getState().user.staff) {
      data = [
        "launchpad",
        "content",
        "studio",
        "blocks",
        "schema",
        "media",
        "code",
        "leads",
        "redirects",
        "reports",
        "apps",
        // "release",
        "settings",
      ];
    }

    dispatch({
      type: "FETCH_PRODUCTS_SUCCESS",
      payload: {
        data,
      },
    });

    // mimic promise api until we make api request
    return Promise.resolve(data);
  };
}
